import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

const BusinessPartnerContacts = ({ data }) => {
  return (
    <DescriptionList stripEmpty={true} data={data} disableGutters={true}>
      <DescriptionItem
        label={'Company name'}
        field={'affiliateContact.partyName'}
      />
      <DescriptionItem
        label={'AKA'}
        field={'affiliateContact.partyNameShort'}
      />
      <DescriptionItem
        label={'Country'}
        field={'affiliateContact.address.countryName'}
      />
      <DescriptionItem
        label={'State/Province/Region'}
        field={'affiliateContact.address.state'}
      />
      <DescriptionItem label={'City'} field={'affiliateContact.address.city'} />
      <DescriptionItem
        label={'Zip/Postal code'}
        field={'affiliateContact.address.zipCode'}
      />
      <DescriptionItem
        label={'Address line 1'}
        field={'affiliateContact.address.addressLine1'}
      />
      <DescriptionItem
        label={'Address line 2'}
        field={'affiliateContact.address.addressLine2'}
      />
      <DescriptionItem
        label={'Mobile'}
        field={'affiliateContact.contact.mobilePhone'}
      />
      <DescriptionItem
        label={'Phone'}
        field={'affiliateContact.contact.phone'}
      />
      <DescriptionItem
        label={'Email'}
        field={'affiliateContact.contact.email'}
      />
    </DescriptionList>
  );
};

export default BusinessPartnerContacts;
